import { router } from 'expo-router';
import {
    FootnoteRegular,
    IconButton,
    Row,
    RowList,
    SettingsIcon,
    Text,
    YStack,
} from 'smoothie';

import { useListFruitSlices } from '../hooks/useFruitSlices';

export const FruitSlicesListPage = () => {
    const { data: slices = [] } = useListFruitSlices();

    return (
        <YStack
            flex={1}
            width="100%"
            maxWidth={720}
            marginHorizontal="auto"
            padding="$4"
            gap="$3"
        >
            <RowList>
                {slices.map((slice) => {
                    return (
                        <Row
                            key={slice.id}
                            title={slice.name}
                            subtitle={slice.description}
                            subtitleProps={{
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                            }}
                            bottomContent={
                                slice.version ? (
                                    <FootnoteRegular color="$gray1000">
                                        v{slice.version}
                                    </FootnoteRegular>
                                ) : undefined
                            }
                            leftContentOverride={
                                <Text fontSize={22}>{slice.icon ?? '🍋'}</Text>
                            }
                            onPress={() => {
                                router.navigate({
                                    pathname:
                                        slice.pageFrameCount === 1
                                            ? '/fruit-slices/[id]'
                                            : '/fruit-slices/[id]/manage',
                                    params: { id: slice.id },
                                });
                            }}
                            rightContent={
                                slice.canModify ? (
                                    <IconButton
                                        variant="tertiary"
                                        icon={SettingsIcon}
                                        onPress={(e) => {
                                            e.stopPropagation();
                                            router.navigate({
                                                pathname:
                                                    '/fruit-slices/[id]/manage',
                                                params: { id: slice.id },
                                            });
                                        }}
                                    />
                                ) : undefined
                            }
                        />
                    );
                })}
            </RowList>
        </YStack>
    );
};
